import { useCircleAIShellStore } from "@circle-react-uikit/CircleAIAppShell/store/circleAIShellStore";
import { useLayoutEffect } from "react";

import { markCircleAiIntroPending } from "./useCircleAiIntroSession";

export const useCircleAiIntroCloseTrigger = (
  userId: number | undefined,
  isFullPageAiRoute: boolean,
) => {
  useLayoutEffect(
    () =>
      useCircleAIShellStore.subscribe((state, previousState) => {
        const wasOpen = previousState.conversationPanelState !== "closed";
        const isClosed = state.conversationPanelState === "closed";

        if (wasOpen && isClosed && !isFullPageAiRoute) {
          markCircleAiIntroPending(userId);
        }
      }),
    [isFullPageAiRoute, userId],
  );
};
